<template>
  <div>
    <pogs-cases :closedCases="closedCases" :pagesProp="pages" />
  <!--  <pogs-maternal-fetal-cases v-if="isMaternalFetalCase" :maternalFetalCases="cases" />
    <pogs-gyne-cases v-if="isGyneCase" :gyneCases="cases"/>
    <pogs-maternal-mortality-cases v-if="isMaternalMortalityCase" :maternalMortalityCases="cases" />
    <pogs-gtd-cases v-if="isGtdMaternal" :gtdCases="cases" />-->
  </div>
</template>

<script>
  import {mapGetters, mapActions} from 'vuex'
  import {
    GETTER_CLOSED_CASES,
    ACTION_LOAD_CLOSED_CASES,
    GETTER_ALL_CLOSED_CASES, ACTION_LOAD_ALL_CLOSED_CASES,
    GETTER_CLOSED_CASES_PAGES
  } from "../../../../store/modules/submissions";

  import PogsCases from '../cases/pogs-submissions__cases--closed'
  import PogsMaternalFetalCases from '../cases/pogs-submissions__cases--meternalfetal'
  import PogsGyneCases from '../cases/pogs-submissions__cases--gyne'
  import PogsMaternalMortalityCases from '../cases/pogs-submissions__cases--maternalmortality'
  import PogsGtdCases from '../cases/pogs-submissions__cases--gtd'

  export default {
    name: "pogs-submissions__cases",
    props:{
      selectedCaseType: String
    },
    components: {
      PogsCases,
      PogsMaternalFetalCases,
      PogsGyneCases,
      PogsMaternalMortalityCases,
      PogsGtdCases
    },
    computed: {
      ...mapGetters({
        cases: GETTER_CLOSED_CASES,
        closedCases: GETTER_ALL_CLOSED_CASES,
        pages: GETTER_CLOSED_CASES_PAGES
      }),
      isMaternalFetalCase(){
        return this.$route.params.casetype === this.$options.caseTypes.MATERNAL_FETAL_CASE
      },
      isGyneCase(){
        return this.$route.params.casetype === this.$options.caseTypes.GYNE_CASE
      },
      isMaternalMortalityCase(){
        return this.$route.params.casetype === this.$options.caseTypes.MATERNAL_MORTALITY_CASE
      },
      isGtdMaternal(){
        return this.$route.params.casetype === this.$options.caseTypes.GTD_CASE
      }
    },
    methods: {
      ...mapActions({
        loadCases : ACTION_LOAD_CLOSED_CASES,
        loadAllClosedCases: ACTION_LOAD_ALL_CLOSED_CASES
      })
    },
    caseTypes: {
      MATERNAL_FETAL_CASE:'maternalfetalcase',
      GYNE_CASE: 'gynecase',
      MATERNAL_MORTALITY_CASE: 'maternalmortalitycase',
      GTD_CASE: 'gtdcase'
    },
    mounted(){
      const casetype = this.$route.params.casetype;
      this.loadCases(casetype);
      this.loadAllClosedCases();
    }
  }
</script>

<style lang="scss">

  @import '../../../../scaffolding/scss/pogs-util';

  .submission-cases{
    .pogs-list--panels__header,
    .pogs-list__item{
      display: grid !important;
      grid-template-columns: 20% repeat(3, 20%) 1fr;
      grid-column-gap: space(m);

      & > *:nth-child(-n+3){
        justify-content: flex-start;
      }
    }

    .pogs-list--panels__header{
      & > button{
        padding: 0;
      }

      .smd-checkbox__row{
        padding: 0 0 0 space(xs);
      }
    }

    & > .pogs-list--panels.compact > .pogs-list__item{
      padding: space(xs) space(base) !important;

      & > *:nth-child(n+4){
        @extend %flex-col--center-xy;
      }
    }

    .patient{
      @include make-grid-cols(42px 1fr, space(base));

      .patient-data__meta{
        grid-template-columns: 130px auto;
        grid-column-gap: 0px;

        p{
          font-size: 13px;
          color: color(dark);
        }
      }
    }
  }

  .submission-cases__pagination {
    @extend %flex-row--center-xy;
    margin: 0 !important;
    padding: space(base);
  }

</style>
